export const MEDIA_MOBILE = '(max-width: 425px)';
export const MODAL_MAX_WIDTH_DESKTOP = 375;
